import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Popover from "@mui/material/Popover";
import { EditText } from "react-edit-text";
import ModalShared from "./ModalShared";
import { color } from "@mui/system";
import stc from "string-to-color";

export default function Planche({
  name,
  image,
  onDelete,
  id,
  onUpdate,
  dashboard,
  isViewOnly,
  isOwner,
}) {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const onClick = () => {
    navigate("/board");
    sessionStorage.setItem("dashboard", JSON.stringify(dashboard));
  };
  const companyRole = useSelector((state) => state.user.role);
  const [anchorEl, setAnchorEl] = useState(null);
  const [label, setLabel] = useState(name);
  const [landa, setLanda] = useState("title-5");
  const [visibility, setVisibility] = useState(false);
  const token = useSelector((state) => state.user.token);
  const userHost = useSelector((state) => state.user);

  const update = () => {
    setAnchorEl(null);
    let element = document.getElementById(`input-default-text-editable-${id}`);
    let evObj = document.createEvent("Events");
    evObj.initEvent("click", true, false);
    element.dispatchEvent(evObj);
    setTimeout(() => {
      document.getElementById(`input-default-text-editable-${id}`).focus();
    }, 250);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  let theme = "1";
  const data = localStorage.getItem("theme");
  if (data) {
    theme = JSON.parse(data).theme;
  }
  const adjustColorIfCloseToWhite = (
    hex,
    threshold = 200,
    blendFactor = 0.3
  ) => {
    const num = parseInt(hex.slice(1), 16);
    const [r, g, b] = [(num >> 16) & 255, (num >> 8) & 255, num & 255];
    const distanceToWhite = Math.sqrt(
      (255 - r) ** 2 + (255 - g) ** 2 + (255 - b) ** 2
    );

    if (distanceToWhite < threshold) {
      return `#${[r, g, b]
        .map((c) =>
          Math.round(c * (1 - blendFactor))
            .toString(16)
            .padStart(2, "0")
        )
        .join("")}`;
    }

    return hex;
  };
  const [color, setColor] = useState(theme === "0" ? "white" : "black");
  const open = Boolean(anchorEl);
  const tag = open ? `simple-popover${name}` : undefined;
  const lists = dashboard.lists?.length;
  const indicators = dashboard.lists
    ?.map((list) => list.listIndicators)
    .reduce((acc, curr) => acc + curr.length, 0);
  const users = dashboard.userDashboards?.length || 0;

  const user =
    dashboard.userDashboards?.filter((item) => item.role === "OWNER")[0]
      ?.user || userHost;

  return (
    <>
      <ModalShared
        style={{ postion: "absolute" }}
        visibility={visibility}
        dashboard={dashboard}
        onCancel={() => setVisibility(false)}
        token={token}
        isViewOnly={isViewOnly}
      />
      <div className="overflow-hidden w-[350px] ml-[8px] h-[290px] flex justify-between flex-col py-3 transition-shadow bg-white cursor-pointer shadow  hover:shadow-lg">
        <div className="flex items-center justify-between px-2 h-[12%] ">
          {isOwner ? (
            <EditText
              id={`input-default-text-editable-${id}`}
              defaultValue={name}
              value={label}
              onChange={(n) => {
                setLabel(n);
              }}
              className={
                "font-semibold text-[18px] font-poppins m-0 p-0 w-[240px]" +
                landa
              }
              type="text"
              onBlur={() => {
                setColor(theme === "0" ? "white" : "black");
                setLanda("title-5");
              }}
              onEditMode={() => {
                setColor("black");
                setLanda("input-default-text-editable");
              }}
              style={{
                color,
                maxWidth: "235px",
                borderColor: "black",
                borderRadius: "2px",
              }}
              onSave={() => {
                if (!label) {
                  setLabel(name);
                } else {
                  onUpdate(label, id);
                }
              }}
            />
          ) : (
            <p
              className="font-semibold text-[20px] font-poppins m-0 p-0"
              onClick={onClick}
            >
              {name}
            </p>
          )}

          <div className="flex items-center gap-2">
            <div
              aria-describedby={id}
              title={user?.email}
              className="flex items-center justify-center text-lg font-semibold text-white rounded-full select-none w-9 h-9"
              style={{
                backgroundColor: "#04B6EE",
              }}
            >
              {user
                ? user?.firstName?.substr(0, 1)?.toLocaleUpperCase() +
                  "" +
                  user?.lastName?.substr(0, 1)?.toLocaleUpperCase()
                : null}
            </div>
            <i
              aria-describedby={tag}
              className="fa-light fa-ellipsis more"
              style={{
                color:
                  theme === "0"
                    ? "#fff"
                    : theme === "1"
                    ? "#1f2128"
                    : "#1f2128",
              }}
              onClick={handleClick}
            ></i>
          </div>

          <Popover
            id={tag}
            open={open && isOwner}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "left",
            }}
          >
            <div className="mui-popover-custom">
              <ul>
                {isOwner && (
                  <>
                    <li>
                      <a
                        href="#"
                        title="Modifier"
                        className="mui-popover-item"
                        onClick={update}
                      >
                        Modifier
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => {
                          setAnchorEl(null);
                          setVisibility(true);
                        }}
                        title="Inviter à rejoindre"
                        className="mui-popover-item"
                      >
                        Inviter à rejoindre
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        title="Supprimer"
                        className="mui-popover-item"
                        onClick={() => {
                          setAnchorEl(null);
                          onDelete(id);
                        }}
                      >
                        Supprimer
                      </a>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </Popover>
        </div>
        <img
          src={image}
          className="object-cover w-full h-[68%]"
          onClick={onClick}
        />

        <div className="flex items-start justify-around  h-[15%]">
          <div className="flex flex-col items-center justify-center ">
            <svg
              width="31"
              height="30"
              viewBox="0 0 31 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.6038 15.8463C10.9589 16.2013 11.4163 16.3698 11.976 16.352C12.5355 16.334 12.9461 16.1321 13.2078 15.7463L18.6345 7.88475L10.7538 13.2923C10.3616 13.5539 10.1498 13.9562 10.1183 14.499C10.0869 15.042 10.2488 15.4911 10.6038 15.8463ZM12 5C12.9513 5 13.8427 5.12467 14.674 5.374C15.5055 5.62333 16.3084 6.00058 17.0828 6.50575L15.673 7.41725C15.1038 7.11475 14.5138 6.88625 13.903 6.73175C13.292 6.57725 12.6577 6.5 12 6.5C9.78334 6.5 7.89583 7.27917 6.3375 8.8375C4.77917 10.3958 4 12.2833 4 14.5C4 15.2 4.09583 15.8917 4.2875 16.575C4.47917 17.2583 4.75 17.9 5.1 18.5H18.9C19.2833 17.8667 19.5625 17.2083 19.7375 16.525C19.9125 15.8417 20 15.1333 20 14.4C20 13.8 19.926 13.1927 19.778 12.578C19.6298 11.9632 19.4013 11.3795 19.0923 10.827L20.0038 9.41725C20.4974 10.2263 20.8677 11.0356 21.1145 11.8453C21.3612 12.6549 21.4897 13.4963 21.5 14.3693C21.5102 15.2744 21.4083 16.1298 21.1943 16.9355C20.9801 17.7413 20.6577 18.5295 20.227 19.3C20.0948 19.5167 19.9089 19.6875 19.6693 19.8125C19.4294 19.9375 19.173 20 18.9 20H5.1C4.83333 20 4.58175 19.9359 4.34525 19.8077C4.10875 19.6794 3.918 19.4973 3.773 19.2615C3.391 18.5948 3.08333 17.8679 2.85 17.0808C2.61667 16.2936 2.5 15.4333 2.5 14.5C2.5 13.1937 2.74783 11.9656 3.2435 10.8158C3.73917 9.66592 4.41575 8.65883 5.27325 7.7945C6.13092 6.93017 7.13917 6.24833 8.298 5.749C9.457 5.24967 10.691 5 12 5Z"
                fill="#0291B1"
              />
            </svg>
            <p className="text-[9px] font-poppins font-semibold text-baseColor">
              {indicators ? indicators : 0} vue
              {indicators > 1 ? "s" : ""}
            </p>
          </div>
          <div className="flex flex-col items-center justify-center ">
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.75 21.25V19.6057L5.25 18.1057V21.25H3.75ZM7.75 21.25V15.6057L9.25 14.1057V21.25H7.75ZM11.75 21.25V14.1057L13.25 15.6307V21.25H11.75ZM15.75 21.25V15.6307L17.25 14.1307V21.25H15.75ZM19.75 21.25V11.6057L21.25 10.1057V21.25H19.75ZM3.75 15.7192V13.6057L10.5 6.85571L14.5 10.8557L21.25 4.10571V6.21921L14.5 12.9692L10.5 8.96921L3.75 15.7192Z"
                fill="#0291B1"
              />
            </svg>

            <p className="text-[9px] font-poppins font-semibold text-baseColor">
              {lists ? lists : 0} section{lists > 1 ? "s" : ""}
            </p>
          </div>
          <div className="flex flex-col items-center justify-center ">
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.5 18.2886V17.0694C0.5 16.404 0.847417 15.8575 1.54225 15.4299C2.23725 15.0024 3.14308 14.7886 4.25975 14.7886C4.44425 14.7886 4.63008 14.7944 4.81725 14.8059C5.00442 14.8174 5.19292 14.8398 5.38275 14.8731C5.18792 15.1848 5.04333 15.5082 4.949 15.8434C4.85483 16.1787 4.80775 16.5226 4.80775 16.8751V18.2886H0.5ZM6.5 18.2886V16.9136C6.5 16.4454 6.63142 16.0175 6.89425 15.6299C7.15708 15.242 7.53592 14.9039 8.03075 14.6156C8.52558 14.3271 9.11025 14.1108 9.78475 13.9666C10.4591 13.8223 11.1962 13.7501 11.9963 13.7501C12.8116 13.7501 13.5564 13.8223 14.2308 13.9666C14.9051 14.1108 15.4897 14.3271 15.9845 14.6156C16.4795 14.9039 16.8558 15.242 17.1135 15.6299C17.3712 16.0175 17.5 16.4454 17.5 16.9136V18.2886H6.5ZM19.1923 18.2886V16.8781C19.1923 16.5019 19.1477 16.1474 19.0588 15.8146C18.9696 15.4819 18.8359 15.1681 18.6578 14.8731C18.8539 14.8398 19.0414 14.8174 19.2203 14.8059C19.3991 14.7944 19.5757 14.7886 19.75 14.7886C20.8667 14.7886 21.7708 14.9999 22.4625 15.4224C23.1542 15.8447 23.5 16.3937 23.5 17.0694V18.2886H19.1923ZM8.077 16.7886H15.9385V16.6829C15.836 16.279 15.4103 15.9393 14.6615 15.6636C13.9128 15.3879 13.0257 15.2501 12 15.2501C10.9743 15.2501 10.0872 15.3879 9.3385 15.6636C8.58967 15.9393 8.16917 16.279 8.077 16.6829V16.7886ZM4.257 13.8174C3.78567 13.8174 3.383 13.6498 3.049 13.3146C2.715 12.9794 2.548 12.5765 2.548 12.1059C2.548 11.629 2.71567 11.2262 3.051 10.8974C3.38617 10.5685 3.78908 10.4041 4.25975 10.4041C4.73658 10.4041 5.141 10.5685 5.473 10.8974C5.80517 11.2262 5.97125 11.63 5.97125 12.1089C5.97125 12.5735 5.80692 12.9744 5.47825 13.3116C5.14975 13.6488 4.74267 13.8174 4.257 13.8174ZM19.75 13.8174C19.2833 13.8174 18.8814 13.6488 18.5443 13.3116C18.2071 12.9744 18.0385 12.5735 18.0385 12.1089C18.0385 11.63 18.2071 11.2262 18.5443 10.8974C18.8814 10.5685 19.2839 10.4041 19.7518 10.4041C20.2339 10.4041 20.6394 10.5685 20.9683 10.8974C21.2971 11.2262 21.4615 11.629 21.4615 12.1059C21.4615 12.5765 21.2975 12.9794 20.9695 13.3146C20.6415 13.6498 20.235 13.8174 19.75 13.8174ZM12.0035 13.0001C11.2832 13.0001 10.6698 12.7477 10.1635 12.2429C9.65717 11.7382 9.404 11.1253 9.404 10.4041C9.404 9.66844 9.65633 9.05186 10.161 8.55436C10.6658 8.05669 11.2788 7.80786 12 7.80786C12.7355 7.80786 13.3521 8.05636 13.8497 8.55336C14.3472 9.05019 14.596 9.66595 14.596 10.4006C14.596 11.1208 14.3476 11.7341 13.8508 12.2406C13.3538 12.7469 12.738 13.0001 12.0035 13.0001ZM12.0048 11.5001C12.3106 11.5001 12.5689 11.3931 12.7797 11.1791C12.9908 10.9649 13.0962 10.7049 13.0962 10.3991C13.0962 10.0934 12.9912 9.83511 12.781 9.62411C12.5708 9.41328 12.3105 9.30786 12 9.30786C11.6975 9.30786 11.4392 9.41294 11.225 9.62311C11.0108 9.83311 10.9038 10.0934 10.9038 10.4041C10.9038 10.7066 11.0108 10.9649 11.225 11.1791C11.4392 11.3931 11.6991 11.5001 12.0048 11.5001Z"
                fill="#0291B1"
              />
            </svg>

            <p className="text-[9px] font-poppins font-semibold text-baseColor">
              {users ? users : 0} utilisateur
              {users > 1 ? "s" : ""}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
